<template>
  <a-modal
    title="支付订单"
    :visible="visible"
    :confirm-loading="confirmLoading"
    ok-text="我已支付"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p>订单号：{{ orderId }}</p>
    <p>交易内容：{{ orderType | valInDict(dict.orderTypeDict) }}</p>
    <p>支付方式：
      <a-radio-group
        v-model="payType"
        size="large"
        @change="postOrderPay"
      >
        <a-radio-button
          v-for="item in dict.payTypeDict"
          :key="item.id"
          :value="item.id"
          class="radio-button"
        >
          <a-icon v-if="item.id === 'WEIXIN'" type="wechat" />
          <a-icon v-if="item.id === 'ALIPAY'" type="alipay-circle" />
          {{ item.name }}
        </a-radio-button>
      </a-radio-group>
    </p>
    <div v-if="payType === 'WEIXIN'" class="qrcode">
      <a-spin v-if="!codeUrl" />
      <a-avatar
        v-if="codeUrl"
        :size="200"
        shape="square"
        :src="codeUrl"
        alt="支付二维码"
      />
      <a-button
        type="primary"
        shape="circle"
        class="fresh-qrcode-btn"
        icon="redo"
        @click="postOrderPay"
      />
    </div>
    <div class="money">{{ payType | valInDict(dict.payTypeDict) }}支付 <span class="red fw-b">￥{{ price }}</span> </div>
    <div v-if="payType === 'WEIXIN'">使用微信扫一扫支付订单，若支付后未自动刷新，请手动点击【我已支付】刷新页面。若支付失败，可前往打印管理-打印订单重新支付</div>
    <div v-if="payType === 'ALIPAY'">您将使用支付宝网页支付支付订单，支付成功后将自动刷新页面，若支付成功后未自动刷新，请手动点击我已支付刷新页面。若支付失败，可前往打印管理-打印订单重新支付</div>
  </a-modal>
</template>

<script>
import { postOrderPay, queryPayResult } from '@/api/print'

export default {
  data() {
    return {
      orderId: 0,
      visible: false,
      confirmLoading: false,
      payType: this.defaultPayType,
      dict: {
        payTypeDict: [{ id: 'WEIXIN', name: '微信' }, { id: 'ALIPAY', name: '支付宝' }],
        orderTypeDict: [
          { id: 'RECHARGE', name: '充值订单' },
          { id: 'PRINT', name: '打印订单' },
          { id: 'ANNUAL', name: '续费订单' }
        ]
      },
      codeUrl: '', // 二维码
      timer: null
    }
  },
  props: {
    // 支付方式（WEIXIN-微信扫码；ALIPAY-支付宝扫码）
    defaultPayType: {
      type: String,
      default: 'WEIXIN'
    },
    // 订单类型（RECHARGE-充值订单；PRINT-打印订单；ANNUAL-续费订单）
    orderType: {
      type: String,
      default: 'PRINT'
    },
    // 价格
    price: {
      type: [String, Number],
      default: 0
    }
  },
  watch: {
    defaultPayType(val) {
      this.payType = val
    }
  },
  methods: {
    showModal(orderId) {
      this.visible = true
      this.orderId = orderId
      setTimeout(() => {
        this.postOrderPay()
      }, 0)
    },
    handleOk() {
      clearInterval(this.timer)
      this.timer = null
      this.confirmLoading = true
      this.visible = false
      this.$emit('close')
    },
    handleCancel() {
      this.visible = false
      clearInterval(this.timer)
      this.timer = null
      this.$emit('close')
    },
    // 获取支付订单二维码
    postOrderPay() {
      this.codeUrl = ''
      postOrderPay({
        order_type: this.orderType,
        orderId: this.orderId,
        pay_type: this.payType,
        return_url: window.location.href
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (this.payType === 'ALIPAY') {
              const divForm = document.getElementsByTagName('divform')
              if (divForm.length) {
                document.body.removeChild(divForm[0])
              }
              const div = document.createElement('divform')
              div.innerHTML = data // data就是sb支付宝返回给你的form
              document.body.appendChild(div)
              document.getElementById('alipaysubmit').setAttribute('target', '_blank') // 加了_blank可能出问题所以我注释了
              document.getElementById('alipaysubmit').submit()
            } else {
              this.codeUrl = data.code_url
            }
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
              this.queryPayResult()
            }, 1000)
          }
        })
        .catch((e) => {
          this.$message.error('请求支付失败')
        })
    },
    // 检查订单是否完成支付
    queryPayResult() {
      queryPayResult({
        order_type: this.orderType,
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (data.pay === 'SUCCESS') {
              this.$message.success(res.message)
              this.handleOk()
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求订单是否完成支付失败')
        })
    }
  }
}
</script>
<style lang="less" scoped>
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 30px auto 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 30px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
.radio-button{
  margin-right: 10px;
  border-radius: 4px !important;
}
</style>
